import { SvgIcon, SvgIconProps } from '@mui/material';

export const TamaraLogo = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 25 24" {...props}>
        <path
            d="M5.47849 9.37553C5.12071 9.74916 4.84036 10.1898 4.65356 10.6722L10.3678 15.4137C10.6491 15.2408 10.9075 15.0332 11.1371 14.7959L11.2482 14.6801C13.4141 12.42 11.9912 9.97163 11.1286 9.14105C10.7572 8.78513 10.3192 8.50586 9.83981 8.31919C9.36039 8.13253 8.84891 8.04213 8.33455 8.05314C7.8202 8.06416 7.31305 8.17639 6.84207 8.38341C6.37109 8.59043 5.94551 8.8882 5.58961 9.25971L5.47849 9.37553Z"
            fill="black"
        />
        <path
            d="M17.2743 15.9588C19.4607 15.9588 21.2332 14.1863 21.2332 11.9999C21.2332 9.81347 19.4607 8.04102 17.2743 8.04102C15.0879 8.04102 13.3154 9.81347 13.3154 11.9999C13.3154 14.1863 15.0879 15.9588 17.2743 15.9588Z"
            fill="black"
        />
    </SvgIcon>
);